import { initFederation } from '@angular-architects/native-federation';
import { environment } from './environments/environment';

console.log('RUTAS INYECTADAS EN ESTE BUILD:', environment.microfrontends);

initFederation(environment.microfrontends)
  .catch((err) => console.error(err))
  .then((_) => import('./bootstrap'))
  .catch((err) => console.error(err));
